// src/components/authentication/logout.jsx
import { API_URL } from '../../config';

export const handleLogout = () => {
  // Reset user_id in GA
  if (window.setGAUserId) {
    window.setGAUserId(null);
  }

  fetch(`${API_URL}/clear-cookie`, {
    method: 'GET',
    credentials: 'include', // Ensure cookies are sent with the request
  })
    .then((response) => {
      if (response.ok) {
        console.log('Куки удалены');
        localStorage.removeItem('token'); // Remove token from local storage
        // Add any other actions necessary, like redirecting or updating UI
      } else {
        console.error('Ошибка при удалении кук:', response.statusText);
      }
    })
    .catch((error) => {
      console.error('Ошибка при удалении кук:', error);
    });
};